'use strict';

import angular from 'angular';

function GroupResource($resource) {
  return $resource('/api/groups/:groupId/:controller', {
    groupId: '@id'
  }, {
    query: { // query params used for instead of url :id
      method: 'GET',
      isArray: true,
      url: '/api/groups'
    },
    queryReport: {
      method: 'GET',
      isArray: true,
      params: { controller: 'report' }
    },
    getTimePeriods: { // query params used for instead of url :id
      method: 'GET',
      isArray: true,
      params: { controller: 'timeperiods' }
    },
    create: {
      method: 'POST',
      url: '/api/groups'
    },
    update: { method: 'PUT' }
  });
}

GroupResource.$inject = ['$resource'];

export default angular.module('georgeApp.groupSvc', [])
  .factory('GroupSvc', GroupResource)
  .name;
